<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' ref='form' :inline='true' :model='queryForm' class='query-form' label-width='80px'
                 size='small' @submit.native.prevent>
            <el-form-item label='奖项名称'>
                <el-input v-model='queryForm.itemName'></el-input>
            </el-form-item>
            <el-form-item label='抽中概率'>
                <el-input v-model='queryForm.itemRatio'></el-input>
            </el-form-item>
            <el-form-item label='奖品数量'>
                <el-input v-model='queryForm.itemNumber'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon='el-icon-search' size='small' type='primary' @click='getMarketTurntableItemList'>查询
                </el-button>
                <el-button icon='el-icon-refresh' size='small' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        icon='el-icon-plus'
                        size='small'
                        type='primary'
                        @click='addMarketTurntableItem'
                    >新建
                    </el-button>
                    <el-button
                        :disabled='multipleSelection.length != 1'
                        icon='el-icon-edit'
                        plain
                        size='small'
                        type='warning'
                        @click='editMarketTurntableItem(null)'
                    >修改
                    </el-button>
                    <el-button
                        :disabled='multipleSelection.length <= 0'
                        icon='el-icon-delete'
                        plain
                        size='small'
                        type='danger'
                        @click='deleteMarketTurntableItem(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               :http-request='upload'
                               :show-file-list='true'
                               action='#'
                               class='upload-demo'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        class='icon-box'
                        title='搜索'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='下载模板'-->
<!--                        @click='importTemplate'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDown />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='导入数据'-->
<!--                        @click='isImport'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowExportUp24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
<!--                    <span-->
<!--                        class='icon-box'-->
<!--                        title='导出数据'-->
<!--                        @click='exportMarketTurntableItemList'-->
<!--                    >-->
<!--                      <Icon color='#606266'>-->
<!--                        <ArrowDownload24Regular />-->
<!--                      </Icon>-->
<!--                    </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMarketTurntableItemList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :cell-style="{padding: '9px'}"
                :data='marketTurntableItemList'
                :header-cell-style="{padding: '10px'}"
                :header-row-style="{height: '10px'}"
                :row-style="{height: '9px'}"
                border
                height='100%'
                row-key='id'
                size='small'
                @selection-change='handleSelectionChange'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='奖项名称'
                    prop='itemName'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='奖项图片'
                    prop='itemPic'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.itemPic'>
                            <el-image
                                @click='updateSrcList(scope.row.itemPic)'
                                style="width: 30px; height: 30px"
                                :src="scope.row.itemPic"
                                :preview-src-list="srcList"
                            > </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='抽中概率'
                    prop='itemRatio'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    label='奖品数量'
                    prop='itemNumber'
                    width='180'
                ></el-table-column>
                <el-table-column
                    align='center'
                    fixed='right'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMarketTurntableItem(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='editMarketTurntableItem(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMarketTurntableItem(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    :current-page.sync='currentPage'
                    :page-size='pageSize'
                    :page-sizes='[10, 20, 50, 100]'
                    :pager-count='7'
                    :total='totalNum'
                    background
                    layout='total, sizes, prev, pager, next, jumper'
                    @size-change='sizeChange'
                    @current-change='currentChange'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='marketTurntableItemStates[marketTurntableItemState]'
                :visible.sync='showDialog'
                :modal='false'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        ref='marketTurntableItemForm'
                        :inline='true'
                        :model='marketTurntableItem'
                        :rules='rules'
                        label-width='120px'
                        size='small'
                    >
                        <el-form-item
                            label='奖项名称'
                            prop='itemName'
                        >
                            <el-input
                                style='width: 200px'
                                v-model='marketTurntableItem.itemName'
                                :disabled="marketTurntableItemState == 'check'"
                                placeholder='请输入奖项名称'
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='抽中概率'
                            prop='itemRatio'
                        >
                            <el-input
                                style='width: 200px'
                                v-model='marketTurntableItem.itemRatio'
                                :disabled="marketTurntableItemState == 'check'"
                                placeholder='请输入抽中概率'
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='奖品类型'
                            prop='awardsType'
                        >
                            <el-select
                                style='width: 200px'
                                v-model='marketTurntableItem.awardsType'
                                :disabled="marketTurntableItemState == 'check'"
                                placeholder='请选择奖品类型'
                                size='small'
                            >
                                <el-option
                                    v-for='(item,index) in awardsTypeEnumList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 3'
                            label='货币类型'
                            prop='awardsDetail'
                        >
                            <el-select
                                size='small'
                                v-model='marketTurntableItem.awardsDetail'
                                style='width: 200px'
                                placeholder='请选择赠送的货币类型'
                                :disabled="marketTurntableItemState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in currencyTypeEnumList'
                                    :key='index'
                                    :label='item.value'
                                    :value='`${item.key}`'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 4'
                            label='选择商品'
                            prop='awardsDetail'
                        >
                            <GridSelect
                                style="width: 200px"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :value="marketTurntableItem.awardsDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValueProduct"
                                :disabled="marketTurntableItemState == 'check'"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelect>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 5'
                            label='选择优惠券'
                            prop='awardsDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择优惠券"
                                labelName="couponName"
                                labelValue="id"
                                :value="marketTurntableItem.awardsDetail"
                                :limit="1"
                                size="small"
                                placeholder="请选择优惠券"
                                @getValue="getValueCoupon"
                                :disabled="marketTurntableItemState == 'check'"
                                :columns="COUPON_code"
                                :searchs="COUPON_search"
                                dataListUrl="/shop/coupon/findList"
                                entityBeanName="shopCoupon"
                                queryEntityUrl="/shop/coupon/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 6'
                            label='选择红包'
                            prop='awardsDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择红包"
                                labelName="leftAmount"
                                labelValue="id"
                                :value="marketTurntableItem.awardsDetail"
                                :limit="1"
                                size="small"
                                placeholder="选择红包"
                                @getValue="getValuePacket"
                                :disabled="marketTurntableItemState == 'check'"
                                :columns="PACKET_code"
                                :searchs="PACKET_search"
                                dataListUrl="/shop/shopredpacket/findList?packetType=5"
                                entityBeanName="shopRedPacket"
                                queryEntityUrl="/shop/shopredpacket/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 7'
                            label='选择购物卡'
                            prop='awardsDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择购物卡"
                                labelName="money"
                                labelValue="id"
                                :value="marketTurntableItem.awardsDetail"
                                :limit="1"
                                size="small"
                                placeholder="选择购物卡"
                                @getValue="getValueCardCash"
                                :disabled="marketTurntableItemState == 'check'"
                                :columns="CARD_code"
                                :searchs="CARD_search"
                                dataListUrl="/shop/shopcardshopping/findList"
                                entityBeanName="shopCardCash"
                                queryEntityUrl="/shop/shopcardshopping/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>
                        <el-form-item
                            v-if='marketTurntableItem.awardsType === 8'
                            label='选择礼品卡'
                            prop='awardsDetail'
                        >
                            <GridSelectIndex
                                style="width: 200px"
                                title="选择礼品卡"
                                labelName="id"
                                labelValue="id"
                                :value="marketTurntableItem.awardsDetail"
                                :limit="1"
                                size="small"
                                placeholder="选择礼品卡"
                                @getValue="getValuePacket"
                                :disabled="marketTurntableItemState == 'check'"
                                :columns="[
                                    {
                                        prop: 'product.productName',
                                        label: '礼品',
                                        img: 'twolabel'
                                    },
                                    {
                                        prop: 'expiredTime',
                                        label: '过期时间(年)',
                                    }
                                ]"
                                :searchs="[
                                    {
                                        prop: 'productName',
                                        label: '礼品',
                                    }
                                ]"
                                dataListUrl="/shop/shopcardpresent/findList"
                                entityBeanName="shopCardPresent"
                                queryEntityUrl="/shop/shopcardpresent/get"
                            >
                            </GridSelectIndex>
                        </el-form-item>

                        <el-form-item
                            label='奖项数量'
                            prop='itemNumber'
                        >
                            <el-input
                                style='width: 200px'
                                v-model='marketTurntableItem.itemNumber'
                                :disabled="marketTurntableItemState == 'check'"
                                placeholder='请输入奖项数量'
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='单次发放'
                            prop='awardsNumber'
                        >
                            <el-input
                                style='width: 200px'
                                v-model='marketTurntableItem.awardsNumber'
                                :disabled="marketTurntableItemState == 'check'"
                                placeholder='请输入单次发放数量'
                                size='small'
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='奖项图片'
                            prop='itemPic'
                        >
                            <el-upload
                                style='width: 200px'
                                class='avatar-uploader'
                                action=''
                                :show-file-list='false'
                                :http-request='uploadTurntableItemImg'
                                :disabled="marketTurntableItemState == 'check'"
                            >
                                <img v-if='marketTurntableItem.itemPic' :src='marketTurntableItem.itemPic' class='avatar' size='small' />
                                <i v-else class='el-icon-plus avatar-uploader-icon'></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        v-if="marketTurntableItemState != 'check'"
                        type='primary'
                        @click='submitForm'
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Delete24Regular,
    Edit24Regular,
    Eye24Regular
} from '@v2icons/fluent';
import { ArrowDown, ArrowUp, GridDots, Printer, Refresh, Search } from '@v2icons/tabler';
import { deleteFun, exprotExcel, get, importDate, importTemplate, post, upload } from '@/utils/request.js';
import { UPLOAD_PATH } from '@/utils/constant';
import GridSelect from '@/components/gridselect/gidselect.vue';
import { PRODUCT, PRODUCT_SEARCH, PACKET, PACKET_SEARCH, COUPON, COUPON_SEARCH, CARD, CARD_SEARCH } from '@/utils/constant.js'
import GridSelectIndex from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectIndex,
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    props:{
        turntableId:{
            type: String,
            default: ''
        }
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMarketTurntableItemList();
                this.getMarketTurntableItemList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMarketTurntableItemList();
                this.getMarketTurntableItemList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            PRODUCT_search: PRODUCT_SEARCH,
            PRODUCT_code: PRODUCT,
            PACKET_code: PACKET,
            PACKET_search: PACKET_SEARCH,
            COUPON_search: COUPON_SEARCH,
            COUPON_code: COUPON,
            CARD_code: CARD,
            CARD_search: CARD_SEARCH,
            srcList:[''], //大预览图
            awardsTypeEnumList: [],
            currencyTypeEnumList: [],

            queryForm: {
                itemName: '', //奖项名称
                itemPic: '', //奖项图片
                itemRatio: '', //抽中概率
                itemNumber: '', //奖品数量
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            marketTurntableItemState: 'add',
            marketTurntableItemStates: {
                add: '新建奖项',
                check: '查看奖项',
                edit: '修改奖项'
            },

            multipleSelection: [],
            marketTurntableItemList: [],
            marketTurntableItem: {
                itemName: '', //奖项名称
                itemPic: '', //奖项图片
                itemRatio: '', //抽中概率
                itemNumber: '', //奖项数量
                turntableId: this.turntableId,
                awardsType: '', //奖品类型
                awardsDetail: '', //奖品内容
                awardsNumber: '', //奖品数量
            },
            btnLoading: false,

            rules: {
                itemName: [{ required: true, message: '奖项名称不能为空', trigger: 'blur' }],
                itemPic: [{ required: true, message: '奖项图片不能为空', trigger: 'blur' }],
                itemRatio: [{ required: true, message: '抽中概率不能为空', trigger: 'blur' }],
                itemNumber: [{ required: true, message: '奖品数量不能为空', trigger: 'blur' }],
                awardsType: [{ required: true, message: '奖品类型不能为空', trigger: 'blur' }],
                awardsDetail: [{ required: true, message: '奖品内容不能为空', trigger: 'blur' }],
                awardsNumber: [{ required: true, message: '奖品数量不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getAwardsTypeEnum();
        this.getCurrencyTypeEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMarketTurntableItemList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.marketTurntableItemList = [];
        },
        resetDialog() {
            this.marketTurntableItemState = 'add';
            this.showDialog = false;
            this.queryForm = {
                itemName: '', //奖项名称
                itemPic: '', //奖项图片
                itemRatio: '', //抽中概率
                itemNumber: '', //奖品数量
            };
            this.getMarketTurntableItemList();
        },
        closeDialog() {
            this.showDialog = false;
            this.marketTurntableItem = {
                itemName: '', //奖项名称
                itemPic: '', //奖项图片
                itemRatio: '', //抽中概率
                awardsType: '', //奖品类型
                itemNumber: '', //奖品数量

                turntableId: this.turntableId
            };
        },
        submitForm() {
            if (this.marketTurntableItemState == 'add') {
                this.$refs.marketTurntableItemForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/turntableitem/add`, { ...this.marketTurntableItem }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableItemList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.marketTurntableItemState == 'edit') {
                this.$refs.marketTurntableItemForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/market/turntableitem/edit`, { ...this.marketTurntableItem }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMarketTurntableItemList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addMarketTurntableItem() {
            this.showDialog = true;
            this.marketTurntableItemState = 'add';
        },
        checkMarketTurntableItem(marketTurntableItemId) {
            console.log(marketTurntableItemId);
            this.currentMarketTurntableItemId = marketTurntableItemId;

            this.getMarketTurntableItemById();
            this.showDialog = true;
            this.marketTurntableItemState = 'check';
        },
        editMarketTurntableItem(marketTurntableItemId) {
            console.log('marketTurntableItem', marketTurntableItemId);
            if (marketTurntableItemId) {
                this.currentMarketTurntableItemId = marketTurntableItemId;
                this.getMarketTurntableItemById();
            } else {
                this.marketTurntableItem = { ...this.marketTurntableItem, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.marketTurntableItemState = 'edit';
        },
        deleteMarketTurntableItem(marketTurntableItemId) {
            let ids = '';
            if (marketTurntableItemId) {
                ids = marketTurntableItemId;
            } else {
                ids = this.multipleSelection.map((marketTurntableItem) => marketTurntableItem.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/market/turntableitem/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMarketTurntableItemList();
                            this.getMarketTurntableItemList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMarketTurntableItemList() {
            this.resetMarketTurntableItemList();
            this.getMarketTurntableItemList();
        },
        getMarketTurntableItemList(query = {}) {
            this.loading = true;
            get(`/market/turntableitem/findList`, {
                ...this.queryForm,
                turntableId: this.turntableId,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.marketTurntableItemList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getMarketTurntableItemById() {
            get(`/market/turntableitem/get`, { id: this.currentMarketTurntableItemId }).then((res) => {
                if (res.success) {
                    this.marketTurntableItem = { ...this.marketTurntableItem, ...res.marketTurntableItem };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportMarketTurntableItemList() {
            //this.btnLoading = true;
            exprotExcel(`/market/turntableitem/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/market/turntableitem/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/market/turntableitem/importData`, formData);
            this.refreshMarketTurntableItemList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMarketTurntableItemList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMarketTurntableItemList();
        },
        // 上传奖品图片
        uploadTurntableItemImg(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.marketTurntableItem.itemPic = res.url;
                }
            });
        },
        // 查看图片
        updateSrcList(src){
            this.srcList[0] = src
        },
        // 获取奖项类型
        getAwardsTypeEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'awards_type'
            }).then((res)=>{
                if(res.success){
                    this.awardsTypeEnumList = res.enumList
                }
            })
        },

        // 获取 CurrencyTypeEnum
        getCurrencyTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'currency_type'
            }).then((res) => {
                if (res.success && res.code === 200) {
                    this.currencyTypeEnumList = res.enumList;
                }
            });
        },

        getValueProduct(value){
            this.marketTurntableItem.awardsDetail = value
        },
        getValueCoupon(value){
            this.marketTurntableItem.awardsDetail = value
        },
        getValuePacket(value){
            this.marketTurntableItem.awardsDetail = value
        },
        getValueCardCash(value){
            this.marketTurntableItem.awardsDetail = value
        },
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
</style>